import { Link } from "react-router-dom/cjs/react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="footer-top footer-bg pt-60">
        {/* newsletter-area */}
        {/* newsletter-area-end */}
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer-widget mb-50">

                <div className="footer-logo mb-35">
                  <a href="/">
                    <img src="/assets/img/logo/logo.png" alt="logo" />
                  </a>
                </div>




                <div className="footer-text">
                  <p>
                    {" "}
                    Welcome to Obigin Media Lab - where imagination meets gameplay. We build thrilling HTML , Android, and Smart TV games for the world to enjoy.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-sm-6">
           <div className="footer-possition">
                <div className="footer-widget mb-50">
                  <div className="fw-title mb-20">
                    <h5>QUICK LINKS</h5>
                  </div>
                  <div className="fw-link">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/web-games">Our Games</Link>
                      </li>
                      <li>
                        <Link to="/blogs">News & Updates</Link>
                      </li>
                      <li>
                        <Link to="/technology">Technology</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              <div className="col-xl-2 col-lg-3 col-sm-6">
              <div className="footer-widget mb-50">
                <div className="fw-title mb-20">
                  <h5>LEGAL</h5>
                </div>
                <div className="fw-link">
                  <ul>
                    <li style={{
                      textWrap:"nowrap"
                    }} >
                      <Link to="/terms-conditions">Terms &amp; Conditions</Link>
                    </li>
                    <li style={{
                      textWrap:"nowrap"
                    }}>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
           
            </div>
            </div>
            
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer-widget mb-50">
                <div className="fw-title mb-35">
                  <h5>WE ARE LOCATED IN</h5>
                </div>
                <div className="footer-contact">
                  <ul>
                    <li>
                      <i className="fas fa-map-marker-alt" />{" "}
                      <span>Address : </span>2nd Floor, 1-98/5/2/1, Block-
                      B,Eternal Samyuktha, Vittal Rao Nagar,Madhapur, Hyderabad,
                      Telangana, 500081
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div className="footer-fire">
            <img src="assets/img/images/footer_fire.png" alt="" />
          </div>
          <div className="footer-fire footer-fire-right">
            <img src="assets/img/images/footer_fire.png" alt="" />
          </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="copyright-text">
                <p>
                  Copyright © 2025 <a href="/#">Obigin Games</a> All Rights
                  Reserved.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 d-none d-md-block">
              <div className="payment-method-img text-right">
                <div className="footer-social">
                  <ul>
                    <li>
                      <a target='_blank' rel="noreferrer" href="https://www.linkedin.com/company/obigin-media-labs/">
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
